import {AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Vendor} from '@app/model/vendor.model';
import {FACET_PUBLISHER, FacetSearchService, RELEVANCE} from '@app/services/facet-search.service';
import {DcpVendorJson, JsonService, SlmTransactionType} from '@dcp/configurator';
import {Product} from '@spartacus/core';
import {CurrentProductService} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {DcpProductUtilitiesService} from '../../services/dcp-product-utilities.service';
import {NavigationLink} from '../navigation-bar/navigation-link';
import {ProductDetailsNavigationLinkService} from '../navigation-bar/product-details-navigation-link.service';
import {ProductDetailsSectionComponent} from '../product-details-section/product-details-section.component';

export const PARTNER_SLM_TRANSACTION_TYPE: SlmTransactionType = {
  code: 'LEAD_RFI',
  name: 'Contact Publisher',
  label: 'productDetails.cta.rfi'
};
export const SAP_SLM_TRANSACTION_TYPE: SlmTransactionType = {
  code: 'CONTACT_SUPPORT',
  name: 'Contact Publisher',
  label: 'productDetails.cta.rfi'
};

@Component({
  selector: 'dcp-default-publisher',
  templateUrl: './publisher.component.html',
  styleUrls: ['./publisher.component.scss'],
})
export class PublisherComponent extends ProductDetailsSectionComponent implements OnInit, OnDestroy, AfterContentInit {
  product$: Observable<Product>;
  product: Product;
  vendor: Vendor;
  logo: string;
  name: string;
  code: string;
  description: string;
  website: string;
  navLink: NavigationLink = {
    headline: 'productDetails.publisher',
    id: 'publisher-section',
  };
  slmTransactionTypes: SlmTransactionType[];

  constructor(
    protected facetSearchService: FacetSearchService,
    protected currentProductService: CurrentProductService,
    protected changeDetection: ChangeDetectorRef,
    protected navigationLinkService: ProductDetailsNavigationLinkService,
    protected jsonService: JsonService,
    dcpProductUtilitiesService: DcpProductUtilitiesService
  ) {
    super(currentProductService, changeDetection, navigationLinkService, dcpProductUtilitiesService);
  }

  get hasLogo(): boolean {
    return !!this.logo;
  }

  isVisible(): boolean {
    return !!this.vendor;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();
  }

  openPublisherSolutions(publisherName: string): void {
    this.facetSearchService.searchByFacet(RELEVANCE + FACET_PUBLISHER, publisherName);
  }

  openPublisherSolutionsWithKeyboard(publisherName: string, event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.openPublisherSolutions(publisherName);
    }
  }

  prepareData(): void {
    if (this.product) {
      this.slmTransactionTypes = [this.isSapProduct ? SAP_SLM_TRANSACTION_TYPE : PARTNER_SLM_TRANSACTION_TYPE];
      this.vendor = this.product.vendor;
      if (this.vendor) {
        if (this.vendor.logo && this.vendor.logo[0]) {
          this.logo = this.vendor.logo[0].url;
        }
        this.name = this.vendor.name;
        this.code = this.vendor.code;
        this.website = this.vendor.website;
        this.setDescription();
      }
    }
  }

  setDescription() {
    const json = this.findAttribute('description');
    if (json && json.description?.trim()) {
      this.description = json.description;
    } else {
      this.description = this.vendor.description;
    }
  }

  findAttribute(entryType: string): DcpVendorJson {
    let attribute;
    const rawAttr = this.vendor.json?.find((entry) => entry.type === entryType);
    if (rawAttr) {
      attribute = this.jsonService.parseSafely(rawAttr.value) as DcpVendorJson;
    }
    return attribute;
  }
}
